import { Action } from '../types';

/**
 * The token itself is _not_ stored in state, because it is stored in a cookie by the AWS Captcha SDK, meaning that we
 * won't know when/if it updates, so we want to fetch the value as close as possible to the time it's used
 */
export interface State {
  /* Whether or not the modal that we render the AWS Captcha challenge puzzle in is open */
  isCaptchaPuzzleModalOpen: boolean;
  /* Whether the user has successfully completed the captcha puzzle */
  isPuzzleCompleted: boolean;
}

export const defaultState: State = {
  isCaptchaPuzzleModalOpen: false,
  isPuzzleCompleted: false,
};

const awsCaptcha = (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case 'OPEN_AWS_CAPTCHA_MODAL':
      return {
        ...state,
        isCaptchaPuzzleModalOpen: true,
        isPuzzleCompleted: false,
      };
    case 'AWS_CAPTCHA_PUZZLE_COMPLETED':
      return {
        ...state,
        isPuzzleCompleted: true,
      };
    case 'CLOSE_AWS_CAPTCHA_MODAL':
      return {
        ...state,
        isCaptchaPuzzleModalOpen: false,
        isPuzzleCompleted: false,
      };
    default:
      return state;
  }
};

export default awsCaptcha;
